import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
// WHY: cannot express "greater than the current target" here -- that value lives in the
// database; Task 9 enforces the raise-only rule.
export const raiseWorkOrderComponentTargetInputSchema = z.object({
    workOrderItemId: requiredUuidString('Component is required.', 'Invalid component selection.'),
    qtyTarget: z
        .number()
        .positive('Quantity target must be greater than zero.')
        .max(1_000_000_000, 'Quantity target must be 1,000,000,000 or less.'),
});
//# sourceMappingURL=raise-component-target-input.js.map